export default __webpack_public_path__ + "static/media/placeholder_dummy2016-ferienwohnung01-mobile-de.e0289b28.png";